import { connect } from 'react-redux';
import { withAuth } from 'components/provider/Auth';
import { withRouter, Route } from 'react-router-dom';
import LoginRedirect from '../LoginRedirect';
import NotFound from 'components/route/NotFound';
import PaddedPage from 'components/shared/PaddedPage';
import PropTypes from 'prop-types';
import React from 'react';

const SponsorRoute = ({
  account,
  component: TheComponent,
  render,
  ...props
}) => {
  return (
    <Route
      {...props}
      render={props => {
        if (typeof account === 'undefined') return <PaddedPage {...props} />;
        if (account === null) return <LoginRedirect {...props} />;
        if (!account?.data?.isSponsor) return <NotFound {...props} />;
        return render ? render(props) : <TheComponent {...props} />;
      }}
    />
  );
};

SponsorRoute.contextTypes = {
  component: PropTypes.object
};

export default withRouter(
  withAuth(
    connect(
      null,
    )(SponsorRoute)
  )
);
